import React, { useContext, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { MaintenanceModeContext, MaintenanceType } from '@context/MaintenanceModeContext'

import { SystemNotification } from '../systemNotification/SystemNotification'

export const MaintenanceMessage = () => {
  const { t } = useTranslation()
  const { isMaintenanceMode, maintenance } = useContext(MaintenanceModeContext)

  const maintenanceTitle = useMemo(() => {
    if (!isMaintenanceMode || !maintenance.Message) {
      return ''
    }

    // translation key-based messages
    if (maintenance.Message === MaintenanceType.MessageWithStartDate) {
      return t('maintenance.MessageWithStartDate', {
        startDate: maintenance.startDate,
        endDate: maintenance.endDate,
      })
    }

    if (maintenance.Message === MaintenanceType.MessageWithEndDate) {
      return t('maintenance.MessageWithEndDate', {
        endDate: maintenance.endDate,
      })
    }

    if (maintenance.Message === MaintenanceType.MessageWithEndDateTime) {
      return t('maintenance.MessageWithEndDateTime', {
        endDateTime: maintenance.endDateTime,
      })
    }

    if (maintenance.Message === MaintenanceType.MessageWithStartDateTime) {
      return t('maintenance.MessageWithStartDateTime', {
        startDateTime: maintenance.startDateTime,
        endDateTime: maintenance.endDateTime,
      })
    }

    //  direct message (legacy)
    return maintenance.Message
  }, [t, isMaintenanceMode, maintenance])

  const showNotification = useMemo(() => {
    if (isMaintenanceMode) {
      return true
    }
    // legacy hardcoded maintenance check - for backward capability
    const currentDate = new Date()
    const maintenanceStartDate = new Date('June 22, 2024 09:00:00 GMT+3')
    const maintenanceEndDate = new Date('June 22, 2024 11:35:00 GMT+3')

    return currentDate >= maintenanceStartDate && currentDate <= maintenanceEndDate
  }, [isMaintenanceMode])

  return showNotification ? <SystemNotification title={maintenanceTitle} /> : null
}
